<div class="broadband-tablet-view">
    <xm-fcc-card page="line-details">
        <xm-fcc-broadband-label
            class="fcc-label"
            [labelDetails]="tabletLabel">
        </xm-fcc-broadband-label>
    </xm-fcc-card>
</div>

